<template lang="pug">
  .final-report
    title-bar
      span {{ $t('结案信息') }}
      span(
        v-if="!isHidden"
        @click="$emit('onView')"
      ) {{ $t('报价明细') }}
    div(style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('Sub SOW') }}
        el-col(:span="20")
          span {{ data.sub_final_scope_name }}

      el-row
        el-col(:span="4") {{ $t('供应商') }}
        el-col(:span="20")
          span {{ data.vendor_name_ch }}/{{ data.vendor_name }}

      Category(:data="data.category_scope")

      template(
        v-if='!hideContracts'
        v-for="item, i in data.contracts"
      )
        contract-and-do-item(:item="item" :index="i")
      el-row
        el-col(:span="4") {{ $t('结案信息') }}
        el-col(:span="20")
          a(
            :href="data.download_url"
            target="_blank"
          ) {{ data.report_name }}
      el-row(v-if='data.material_desc_path')
        el-col(:span="4") {{ $t('材料说明') }}
        el-col(:span="20")
          a(
            :href="data.material_download_url"
            target="_blank"
          ) {{ data.material_file_name }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import Category from '@/components/Category'
import ContractAndDoItem from '@/components/ContractAndDoItem'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    hideContracts: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ContractAndDoItem,
    Category,
    TitleBar
  }
}
</script>

<style lang="stylus">
.final-report
  .title-bar
    justify-content space-between
</style>
